import { Box, Container, Paper } from "@mui/material";
import useGetLogo from "src/components/logo/hooks/use-logo";
import { useTheme } from "@mui/material/styles";

const AuthLayout = ({ children }) => {
  const logo = useGetLogo();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        backgroundColor: theme.palette.background.neutral,
        py: { xs: 6, md: 8 },
        px: 2,
      }}
    >
      {/* Background ambient radial glows */}
      <Box
        sx={{
          position: "absolute",
          top: "-120px",
          left: "-120px",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          background: `radial-gradient(circle, ${theme.palette.primary.main}18 0%, rgba(0,0,0,0) 70%)`,
          filter: "blur(60px)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-120px",
          right: "-120px",
          width: "450px",
          height: "450px",
          borderRadius: "50%",
          background: `radial-gradient(circle, ${theme.palette.secondary.main}18 0%, rgba(0,0,0,0) 70%)`,
          filter: "blur(70px)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3.5, sm: 5 },
            borderRadius: "24px",
            border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(12, 88, 64, 0.08)"}`,
            boxShadow: isDark
              ? "0 20px 60px 0 rgba(0, 0, 0, 0.6)"
              : "0 16px 48px 0 rgba(12, 88, 64, 0.08)",
            background: isDark
              ? "rgba(18, 26, 23, 0.9)"
              : "rgba(255, 255, 255, 0.96)",
            backdropFilter: "blur(20px)",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              mb: 3,
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                p: 1.5,
                borderRadius: "20px",
                background: isDark ? "rgba(255,255,255,0.04)" : "rgba(12,88,64,0.04)",
                border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(12,88,64,0.08)"}`,
                boxShadow: "0 4px 16px rgba(0,0,0,0.04)",
                display: "inline-flex",
              }}
            >
              <img style={{ width: "75px", height: "auto" }} src={logo} alt="Jeunesse Éveillée Logo" />
            </Box>
          </Box>
          {children}
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthLayout;
